{
  "salon-booking-config-page": {
    "buttons": {
      "book": "RÉSERVER"
    },
    "text": {
      "black-listed": "Votre option de réservation en ligne dans ce salon est bloquée. Veuillez contacter le salon pour prendre un nouveau rendez-vous",
      "not-found-available-time": "Si vous ne trouvez pas l'heure souhaitée, veuillez nous appeler au numéro de téléphone suivant"
    }
  }
}
